import { createFileRoute } from "@tanstack/react-router"
import { AixContentHeader } from "@aix/ui"
import type { ReactElement } from "react"
import { AdminContentSeedList } from "~/components/Admin/AdminContentSeedList"
import CustomHead from "~/components/SEOHead/CustomHead"
import { SuperAdminLayout } from "~/layouts/SuperAdminLayout"

function AdminContentSeeds() {
  return (
    <>
      <CustomHead />
      <div className="container mx-auto space-y-6">
        <AixContentHeader className="px-8 pt-8">
          <h1 className="text-2xl font-bold">Content Seeds Management</h1>
          <p className="text-muted-foreground">
            Manage content seeds used for video generation across all categories and sources
          </p>
        </AixContentHeader>
        <AdminContentSeedList />
      </div>
    </>
  )
}

function AdminContentSeedsWrapper() {
  return (
    <SuperAdminLayout>
      <AdminContentSeeds />
    </SuperAdminLayout>
  )
}

export const Route = createFileRoute("/admin/content-seeds")({
  component: AdminContentSeedsWrapper,
})
